import { useDispatch } from "react-redux";
import { addToCart } from "../../../../store/features/Cart/actionCreator";
import { decreaseByOne } from "../../../../store/features/Product/actionCreator";

export default function ProductItem({ product }) {
  const dispatch = useDispatch();
  const { name, category, price, quantity, image, id } = product;

  const handleAddToCart = () => {
    if (quantity === 0) {
      return alert("Sorry, this product is out of stock");
    }

    dispatch(addToCart({ ...product, cartQuantity: 1 }));
    dispatch(decreaseByOne(id));
  };

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={image} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{name}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button className="lws-btnAddToCart" onClick={handleAddToCart}>
          Add To Cart
        </button>
      </div>
    </div>
  );
}
